import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/godfather`;

export default {
  async godsons() {
    let apiUrl = store.state.countrySelected.api;
    let params = {};
    params.lang = store.state.langSelected.langWsp;

    try {
      let resp = await axios.get(`${apiUrl}/${apiPath}/godsons`, {
        params: params
      });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async remind(params) {
    let apiUrl = store.state.countrySelected.api;

    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/remind`, params);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async invite(params) {
    let apiUrl = store.state.countrySelected.api;

    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/invite`, params);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
